module.exports = __webpack_public_path__ + "img/m-banner-kfkmkuef-en-US.ac2f9e51.png";